import { render, staticRenderFns } from "./OidcSilent.vue?vue&type=template&id=190929fc"
import script from "./OidcSilent.vue?vue&type=script&lang=js"
export * from "./OidcSilent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports